// src/store/thunks/organization/fetchOrgProfile.ts
import { mapOrgProfileDTOToProfile } from '@/store/mappers/organization';
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import type { OrgProfileDTO } from '@/types/organization.dtos';
import type { OrganizationProfile } from '@/types/organization.types';

export const fetchOrgProfile = createAdminAsyncThunk<
  OrganizationProfile,
  { id: string },
  { rejectValue: string }
>(
  'organization/fetchProfile',
  async({ id }, { extra: { organizationService }, rejectWithValue }) => {
    try {
      const dto: OrgProfileDTO = await organizationService.getProfileById(id);
      const { profile } = mapOrgProfileDTOToProfile(dto);
      return profile;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Failed to fetch organization profile';
      return rejectWithValue(message);
    }
  }
);
